import { t } from '../i18n/index.js';

/**
 * Game Arena logo: an arena ring emblem with a stylised "A" and the word AREENA as the
 * dominant element (gradient, wide letter spacing). Text stays real text for accessibility.
 */
export function Logo(props: { size?: 'small' | 'large'; animated?: boolean }) {
  const size = props.size ?? 'small';
  return (
    <span class={`logo logo-${size} ${props.animated ? 'logo-animated' : ''}`} aria-label={t.appName}>
      <svg class="logo-emblem" viewBox="0 0 48 48" aria-hidden="true">
        <defs>
          <linearGradient id="logo-ring" x1="0" y1="0" x2="1" y2="1">
            <stop offset="0" stop-color="#5cc8ff" />
            <stop offset="1" stop-color="#a78bfa" />
          </linearGradient>
        </defs>
        {/* Arena ring with a gap at the top, like an open stadium */}
        <path
          class="logo-ring"
          d="M30.5 5.2A20 20 0 1 1 17.5 5.2"
          fill="none"
          stroke="url(#logo-ring)"
          stroke-width="4"
          stroke-linecap="round"
        />
        {/* Stylised A: two strokes and a crossbar that is a small spark */}
        <path d="M24 9 L13 37 M24 9 L35 37" stroke="#e8ecf6" stroke-width="4" stroke-linecap="round" fill="none" />
        <path class="logo-spark" d="M24 22.5l1.6 3.4 3.7.4-2.8 2.5.8 3.7-3.3-1.9-3.3 1.9.8-3.7-2.8-2.5 3.7-.4z" fill="#facc15" />
      </svg>
      <span class="logo-word" aria-hidden="true">
        AREENA
      </span>
    </span>
  );
}

/** Animated lobby banner: the logo with slowly floating game pieces in the background. */
export function ArenaHero(props: { subtitle: string }) {
  return (
    <section class="hero" aria-label={t.appName}>
      <div class="hero-pieces" aria-hidden="true">
        {/* Ship */}
        <svg class="piece p1" viewBox="0 0 100 30">
          <path d="M8 15 C8 9 12 7 20 7 L78 7 C88 8 94 12 97 15 C94 18 88 22 78 23 L20 23 C12 23 8 21 8 15Z" fill="#cfe6ff" />
          <rect x="40" y="11" width="20" height="8" rx="2" fill="#8ea0bb" />
        </svg>
        {/* Othello discs */}
        <span class="piece p2 disc disc-w" />
        <span class="piece p3 disc disc-b" />
        {/* Card */}
        <svg class="piece p4" viewBox="0 0 30 40">
          <rect x="1" y="1" width="28" height="38" rx="5" fill="#5b21b6" />
          <path d="M15 12l2.4 5 5.4.8-3.9 3.8.9 5.4-4.8-2.6-4.8 2.6.9-5.4-3.9-3.8 5.4-.8z" fill="#facc15" />
        </svg>
        <span class="piece p5 disc disc-b" />
        <svg class="piece p6" viewBox="0 0 40 40">
          <circle cx="20" cy="20" r="16" fill="none" stroke="#5cc8ff" stroke-width="3" />
          <circle cx="20" cy="20" r="5" fill="#e5484d" />
        </svg>
      </div>
      <div class="hero-content">
        <Logo size="large" animated />
        <p class="hero-subtitle">{props.subtitle}</p>
      </div>
    </section>
  );
}
